module.exports = __webpack_public_path__ + "img/chat_rating_and_review.1beea78.png";